import { Injectable } from '@angular/core';
import {map, Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {AuthService} from "./auth.service";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
    providedIn: 'root'
})
export class ClientService {
    constructor(private http: HttpClient, private auth: AuthService) {}

    /**
     * consulta para obtener los permisos
     */
    getData(): Observable<any>{
        let dataUser = this.auth.getUser()?.id ?? 0;
        const body = JSON.stringify({
            id: dataUser
        });
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/client/getprofile`,
            body,
            { headers }
        )
        .pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }

    /**
     * guarda usuario
     */
    saveClient(data: any): Observable<any>{
        const body = JSON.stringify(data);
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/client/saveclient`,
            body,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }
    /**
     * guarda datos del cliente
     */
    saveData(data: any): Observable<any>{
        const body = JSON.stringify(data);
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/client/savedata`,
            body,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }

    /**
     * Función para mostrar o remover loading
     */
    controlLoader(show:boolean):void{
        // let elemet: any = document.getElementsByClassName("loader-screen")[0];
        // elemet.style.opacity = 0.8;
        // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
    }


}
